import { useContext, useState } from "react"
import { AdminContext } from "~/contexts/AdminContext"
export const useEditInvoiceButton = () => {
  const { selectedReservation, campingStyles, sites } = useContext(AdminContext)
  const [openModal, setOpenModal] = useState<boolean>(false)
  
  const site = sites?.find((s) => s.id === selectedReservation?.site_id) || selectedReservation?.site
  const campingStyle = campingStyles.find((cs) => cs.id === site?.camping_style_id)
  const canOpenModal = openModal && !!selectedReservation

  return { selectedReservation, canOpenModal, setOpenModal, campingStyle }
}
